
function Item({i, hist}){
 
 const {estado, autor, usuario_asignado, mensaje, fecha} = hist;

 return (
  <tr>
   <th className="text-center" scope="row">{i + 1}</th>
   <td className="text-center">
    <button className={`btn btn-${estado === 'detectado' ? 'warning' : estado === 'abierto' ? 'info' : estado === 'asignado' ? 'primary' : estado === 'diagnosticado' ? 'secondary' : estado === 'resuelto' ? 'light' : estado === 'desplegado' ? 'dark' : estado === 'descartado' ? 'danger' : 'success'} text-black btn-sm`} style={{"border": "2px solid black", "fontWeight": "bold", "textTransform": "capitalize"}}>{estado}</button>
   </td>
   <td className="text-center">{autor}</td>
   <td className="text-center">{usuario_asignado}</td>
   <td className="text-center">{mensaje}</td>
   <td className="text-center"> {new Date(fecha).getDate()}/{new Date(fecha).getMonth() + 1}/{new Date(fecha).getFullYear()}</td>

   <td className="text-center">
    {new Date(fecha).getHours().toString().length === 1 
    ? `0${new Date(fecha).getHours()}` 
    : new Date(fecha).getHours()
    } : {new Date(fecha).getMinutes().toString().length === 1
    ? `0${new Date(fecha).getMinutes()}`
    : new Date(fecha).getMinutes()
    } : {new Date(fecha).getSeconds().toString().length === 1 
    ? `0${new Date(fecha).getSeconds()}`
    : new Date(fecha).getSeconds()
    }
   </td>
  </tr>
 )
}
export default Item